const bodyScrollLock = require('body-scroll-lock');
const {parseResponse} = require("../../components/bn_forms");

window.bookChaptersSort = function () {
    let value = $('.book-chapters-sort').val(),
        content = $('.bn_book__chapters-content');

    if (value === 'desc') {
        content.addClass('reverse');
    } else {
        content.removeClass('reverse');
    }
};

$(document).on('click', '.bn_book__navigation', function() {
    let that = $(this),
        target = that.data('target');

    $('.bn_book__navigation').removeClass('active');

    $('#comments').removeClass('top');

    that.addClass('active')

    $('.bn_book__tab').removeClass('active');

    if (history.pushState) {
        history.pushState('', '', '?tab=' + target);
    }

    if (target === 'comments') {
        $('#'+target).addClass('top');
    } else {
        $('#'+target).addClass('active');
    }
});

$(document).on('click', '.bn_book__add-library', function () {
    let that = $(this);

    $.ajax({
        type: 'POST',
        url: '/book/to-library',
        data: {
            bookId: $(this).data('id')
        },
        dataType: 'json',
        success: function (data) {
            that.removeClass('bn_book__add-library');
            that.addClass('bn_book__remove-library');

            flashNotify(data.message);

            parseResponse(data);
        },
    });
});

$(document).on('click', '.bn_book__remove-library', function () {
    let that = $(this);

    $.ajax({
        type: 'POST',
        url: '/book/from-library',
        data: {
            bookId: $(this).data('id'),
            checkCollections: true,
        },
        dataType: 'json',
        success: function (data) {
            parseResponse(data);

            if (data.message) {
                that.addClass('bn_book__add-library');
                that.removeClass('bn_book__remove-library');

                flashNotify(data.message);
            }
        },
    });
});

$(document).on('click', '.bn_accordion__heading', function(e) {
    let that = $(this),
        container = that.parents('.bn_accordion'),
        dropdown = container.find('.bn_accordion__content');

    container.stop().toggleClass('open');

    dropdown.stop().slideToggle();
})

$(document).on('click', '.bn_book__like', function () {
    let that = $(this),
        bookId = that.data('id');

    $.ajax({
        url: '/auth/check-add-like',
        type: 'POST',
        success: function(response) {
            response = $.parseJSON(response);
            if (response.success == false) {
                if (response.error == 'day') {
                    $('#modalLike').modal().modal('open');
                }
                if (response.error == 'code') {
                    $.post('/auth/check-code?action=like&id='+bookId, function (result) {
                        $('body').append($(result));
                        $('#modalVerificationCode').modal().modal('open');
                    });
                }
            } else {
                $.get("/book/like", {'id':bookId, 'ajax': true}, function(data){
                    let counter = that.find('.counter'),
                        value = counter.text(),
                        number = value.replace(/ /g, ''),
                        integer = parseInt(number) + 1;
                    counter.text(integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
                    that.addClass('bn_book__dislike');
                    that.removeClass('bn_book__like');
                });
            }
        },
        error: function (resposnse) {
            console.log(resposnse);
        },
    });
});

$(document).on('click', '.bn_book__dislike', function () {
    let that = $(this);

    $.ajax({
        type: 'POST',
        url: '/book/dislike',
        data: {
            _csrf: $('meta[name=csrf-token]').attr('content'),
            bookId: $(this).data('id'),
            ajax: true
        },
        success: function () {
            let counter = that.find('.counter'),
                value = counter.text(),
                number = value.replace(/ /g, ''),
                integer = parseInt(number) - 1;
            counter.text(integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
            that.removeClass('bn_book__dislike');
            that.addClass('bn_book__like');
        },
    });
});

$(document).on('click', '.bn_book__add-library-mobile', function () {
    let that = $(this);
    $.ajax({
        type: 'POST',
        url: '/book/to-library',
        data: {
            bookId: $(this).data('id')
        },
        dataType: 'json',
        success: function (response) {
            that.removeClass('bn_book__add-library-mobile');
            that.addClass('bn_book__remove-library-mobile');

            dataLayer.push({
                'event': 'autoEvent',
                'eventCategory': 'Book',
                'eventAction': 'Add to library',
                'eventLabel': 'Add to library'
            });

            flashNotify(response.message);

            parseResponse(response);
        },
    });
});

$(document).on('click', '.bn_book__remove-library-mobile', function () {
    let that = $(this);

    $.ajax({
        type: 'POST',
        url: '/book/from-library',
        data: {
            bookId: $(this).data('id'),
            checkCollections: true,
        },
        dataType: 'json',
        success: function (data) {
            parseResponse(data);

            if (data.message) {
                that.addClass('bn_book__add-library-mobile');
                that.removeClass('bn_book__remove-library-mobile');

                flashNotify(data.message);
            }
        },
    });
});

$(document).on('click', '.bn_book__follow', function () {
    let that = $(this);

    $.ajax({
        type: 'POST',
        url: '/account/subscribe/ajax-follow',
        data: {
            authorId: $(this).data('id')
        },
        dataType: 'json',
        success: function (data) {
            that.toggleClass('active');

            flashNotify(data.message);
        },
    });
});

$(document).on('click', '.bn_book__content-main-annotation-more', function () {
    let that = $(this),
        container = that.parents('.bn_book__content-wrapper');

    container.addClass('full');
});

$(document).on('click', '.bn_book__header-recommendation', function () {
    let that = $(this),
        wrapper = $('body'),
        bookId = that.data('book-id');

    $.ajax({
        'type': 'POST',
        'url': '/book/recommend-popup',
        'data': {bookId: bookId},
        'beforeSend': function () {
            $('#bn_recommendation').remove();
            $('#bn_recommendation-error').remove();
            $('#bn_recommendation-success').remove();
        },
        'success': function (result) {
            wrapper.append(result.popup);

            if (result.status === 'success') {
                initializeInputCounters();

                openPopup('#bn_recommendation');
            } else {
                openPopup('#bn_recommendation-error');
            }
        },
        'error': function () {
            console.error('BookCard popup ajax error')
        },
    });
})